























import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import RuleGroupService from '@/domain/scripts/service/rule-group.service';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import RuleGroupResponse from '@/domain/scripts/entity/rule-group-response'
import RuleGroupDatatable from './datatable/rule-group-datatable.component.vue';
import NewRuleGroup from './new-rule-group/new-rule-group.component.vue';

@Component({ components: { RuleGroupDatatable, NewRuleGroup } })

export default class RuleGroupConfiguration extends Vue {
  @Prop() businessUnitId!: string;

  showRuleGroupEdition: boolean = false;

  ruleGroupToEdit: RuleGroup = RuleGroup.of({});

  editModeValue: boolean = false;

  valid: boolean = false;

  previewModeValue: boolean = false;

  preview(ruleGroupId: string) {
    this.getRuleGroup(ruleGroupId);
    this.editModeValue = false;
    this.previewModeValue = true;
  }

  newRuleGroup() {
    this.showRuleGroupEdition = true;
    this.editModeValue = false;
  }

  editRuleGroup(ruleGroupId: string) {
    this.getRuleGroup(ruleGroupId);
    this.editModeValue = true;
    this.previewModeValue = false;
  }

  resetRuleEditionAndPreview() {
    this.ruleGroupToEdit = RuleGroup.of({});
    this.showRuleGroupEdition = false;
    this.editModeValue = false;
    this.previewModeValue = false;
  }

  getRuleGroup(ruleId: string) {
    RuleGroupService.getRuleGroup(this.businessUnitId, ruleId)
      .then((response: RuleGroupResponse) => {
        this.ruleGroupToEdit = RuleGroup.of(response);
        this.showRuleGroupEdition = true;
      })
      .catch((err) => VbSnackbarService.handleHttpError(err));
  }
}

